import React from 'react';

import {Fragment} from 'constants/AssemblyConstants';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface StickyEndsRowProps {
  bases: string;
  downstreamFragment: Fragment;
  revcomp: string;
  showPrintableSummary: boolean;
  upstreamFragment: Fragment;
}

function StickyEndsRow({
  bases,
  downstreamFragment,
  revcomp,
  showPrintableSummary,
  upstreamFragment,
}: StickyEndsRowProps): JSX.Element {
  return (
    <>
      <td
        style={{[showPrintableSummary ? 'borderLeftColor' : 'backgroundColor']: upstreamFragment.color}}
        className="printable-color js-upstream"
      >
        <a>{upstreamFragment.name}</a>
      </td>
      <td
        style={{[showPrintableSummary ? 'borderLeftColor' : 'backgroundColor']: downstreamFragment.color}}
        className="printable-color js-downstream"
      >
        <a>{downstreamFragment.name}</a>
      </td>
      <td>{bases || <span className="faded">N/A</span>}</td>
      <td>{revcomp || <span className="faded">N/A</span>}</td>
    </>
  );
}

export default makeDeprecatedJadeStyleTemplate<StickyEndsRowProps>(StickyEndsRow);
